import $axios from "../../api";

const url = "hr/attendance/store"

const state = () => ({
  isLoading: false,
  isSuccess: false,
  errors: [],
  page: 1,
  list: {},
});

const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  ASSIGN_ERRORS(state, payload) {
    state.errors = payload;
  },
  SET_PAGE(state, payload) {
    state.page = payload;
  },
  SET_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },
  SET_LIST(state, payload) {
    state.list = payload;
  },
};

const actions = {
  async getList({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);

    try {
      const { data } = await $axios.get(`${url}/list`, {
        params: {
          page: state.page,
          ...payload
        }
      })

      commit("SET_SUCCESS", true)
      commit("SET_LIST", data.data)
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, { root: true })
    } finally {
      commit("SET_LOADING", false);
    }
  },
  async updateAttendance({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);

    try {
      await $axios.put(`${url}/update/${payload.id}`, {
        action: payload.action
      })

      commit("SET_SUCCESS", true)
    } catch (error) {
      commit("ASSIGN_ERRORS", error.response.data.errors);
      dispatch("Main/globalSweetAlert", error.response, { root: true })
    } finally {
      commit("SET_LOADING", false);
    }
  },
  exportExcel({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);

    try {
      $axios.get(`${url}/export`, {
        params: {
          start_date: payload?.start_date,
          end_date: payload?.end_date,
        },
        responseType: 'blob'
      }).then((response) => {
        let fileName = 'export.xlsx'
        const contentDisposition = response.headers['content-disposition']
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (fileNameMatch && fileNameMatch[1]) {
            fileName = fileNameMatch[1].replace(/['"]/g, '');
          }
        }
        
        const url = window.URL.createObjectURL(new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }));
        
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      }).catch(async (error) => {
        // Response error datang sebagai Blob (responseType:'blob') — decode dulu
        // ke JSON supaya pesan aslinya muncul, bukan blob mentah. Tanpa .catch,
        // kegagalan (mis. timeout export) hilang diam-diam = "tidak bisa export".
        const res = error.response;
        if (res && res.data instanceof Blob) {
          try { res.data = JSON.parse(await res.data.text()); } catch (e) { /* biarkan apa adanya */ }
        }
        dispatch("Main/globalSweetAlert", res, { root: true });
      })
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, { root: true })
    } finally {
      commit("SET_LOADING", false);
    }
  },
  async bulkAction({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);

    try {
      await $axios.put(`${url}/bulk-update`, payload)
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, { root: true })
    } finally {
      commit("SET_LOADING", false);
    }
  },
  approvalOvertime({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("SET_SUCCESS", false);
    return new Promise((resolve, reject) => {
      $axios
        .put(`${url}/approval-overtime`, payload)
        .then((res) => {
          commit("SET_SUCCESS", true);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("ASSIGN_ERRORS", error.response.data.errors);
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
};